import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Club } from "../../../types-business/Clubs";
import { getPartner } from "../../actions/partners";
import Layout from "../../components/layout";
import PartnersSaleFlow from "../../components/partnersSaleFlow";
import OBLayout from "../../../OnBoardingUI/components/OBLayout/OBLayout.component";
import { setOBTitle } from "../../../OnBoardingUI/components/OBLayout/OBLayout.utils";

interface Props {
  getPartner: (params: object) => void;
  partner: Partner;
}

interface Partner {
  nombrePersona: string;
  nombreMembresia: string;
  nombreConvenio: string;
  certificado: boolean;
  estatusMembresia: string;
  fechaAdquisicion: string;
  fechaInicioMantenimiento: string;
  idClubAlterno: string;
  idClubBase: string;
  idMembresia: string;
  idMembresiaSocio: string;
  idMantenimiento: string;
  idPersona: string;
  intransferible: boolean;
  limiteInicioMantenimiento: string;
  nueva: boolean;
  precioBaseMembresia: string;
  precioVentaMembresia: string;
  ventaEnLinea: boolean;
  membershipDocuments: object[];
}
interface State {
  membershipPartners: any[];
  clubs: Club[];
}

class PartnersSaleFlowPage extends React.Component<Props, State> {
  state = {
    membershipPartners: null,
    clubs: []
  };

  componentDidMount(): void {
    setOBTitle("Proceso de compra");
  }

  render() {
    return (
      <OBLayout>
        {this.state.clubs && (
          <PartnersSaleFlow
            partner={this.props.partner}
            getPartner={this.props.getPartner}
          />
        )}
      </OBLayout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getPartner: (params: object) => {
    return dispatch(getPartner(params));
  }
});

const mapStateToProps = ({ partners }) => {
  return {
    partner: partners.partner
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnersSaleFlowPage);
